import { Outlet } from "react-router";

export const PageBaseLayout = () => {
  return (
    <>
      <Outlet />
    </>
  );
};
